export enum MapModeEnum {
  LOADING = 'loading',
  BEFORE_PICKED_UP = 'BeforePickedUp',
  PICKED_UP = 'PickedUp',
  DOOR_BELL = 'CloseBy',
  DELIVERY_COMPLETED = 'Delivered',
  JOB_CANCELLED = 'JobCancelled',
  ORDER_CANCELLED = 'OrderCancelled',
}

export type Coordinate = {
  latitude: number;
  longitude: number;
};

export type SerializedCoordinate = {
  lat: number;
  lng: number;
};

export enum MarkerTypeEnum {
  RESTAURANT = 'restaurant',
  CUSTOMER = 'customer',
  COURIER = 'courier',
}
